export default {"src":"/_next/static/media/logo-circle.7c4aefe6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};